import axios from 'axios'
 export const getAPIData = (data)=>{
    return axios.get(data?.url)
 }